/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * modules.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * Import module.
 */
import { setCreateSpan } from "./setCreateSpan";
import { setDrawerButton } from "./setDrawerButton";
import { smoothScrollTo } from "./smoothScrollTo";
import { mouseStalker, mouseStalker__contents__weHave__pointImg } from "./setMouseStalker";
import { setScrollTrigger } from "./setScrollTrigger";
import { scrollBar } from "./setScrollBar";
import { setThree } from './setThree';
import { setSplash } from './setSplash';
import { setCreateButton } from "./setCreateButton";

/**
 * 追加処理
 */
function addProcess() {


  /**
   * ホバー検知 - CONTENTS - We have - point__list-item
   */
  const hover__pointListItem = () => {
    let html = document.querySelector('html');
    let pointList = document.querySelector('.--js__hoverDetection');
    let pointListItemArray = Array.prototype.slice.call(pointList.querySelectorAll('.point__list-item'));
    pointListItemArray.forEach((item, index) => {
      item.addEventListener('mouseenter', () => {
        html.classList.add('--show_point0' + (index + 1));
      });
      item.addEventListener('mouseleave', () => {
        html.classList.remove('--show_point0' + (index + 1));
      });
    });
  }

  /**
   * ヘッダーの表示・非表示
   */
  const header__transform = () => {
    const header = document.querySelector('.site-header');
    const title = document.querySelector('.title');

    const observerCallback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          header.classList.remove('visible');
        } else {
          header.classList.add('visible');
        }
      });
    };
    
    const observer = new IntersectionObserver(observerCallback);
    observer.observe(title);
  }

  window.document.body.classList.contains("home") && hover__pointListItem();
  window.document.body.classList.contains("single-post") && header__transform();
}

/**
 * Do modules.
 */
function modules() {
  setCreateSpan();
  window.document.body.classList.contains("home") && smoothScrollTo();
  setDrawerButton();
  setCreateButton();
  mouseStalker();
  mouseStalker__contents__weHave__pointImg();
  addProcess();
  window.document.body.classList.contains("home") && setThree();
  window.document.body.classList.contains("home") && setScrollTrigger();
  scrollBar();
  setSplash();
}

export { modules };
